// DEPRECATED(formsy-retirement): legacy formsy-react field. Use a Formik-based field instead.
import { FormControl, InputLabel, useMediaQuery } from '@mui/material';
import Select from '@mui/material/Select';
import { withFormsy } from 'formsy-react';
import React from 'react';

function SelectBox({ title, name, value, children, style, disabled, fullWidth, setValue, passValue, sx }) {
  const isMediumScreen = useMediaQuery(theme => theme.breakpoints.down('md'));

  const changeValue = event => {
    setValue(event.target.value);
    if (typeof passValue === 'function') {
      passValue(event.target.value);
    }
  };

  return (
    <FormControl fullWidth={fullWidth ?? false} sx={sx ?? {}}>
      <InputLabel id={`${name}-label`}>{title}</InputLabel>
      <Select
        labelId={`${name}-label`}
        label={title}
        name={name}
        value={value}
        onChange={changeValue}
        style={style}
        size={isMediumScreen ? 'medium' : 'small'}
        disabled={disabled}
        inputProps={{
          name: name,
        }}
      >
        {children}
      </Select>
    </FormControl>
  );
}

export default withFormsy(SelectBox);
